export const VerticalsValues = {
  EXCURSION: 'excursions',
  TOURS: 'tours',
  // Дефолтный тип нужен для поддержки новых типов экспириенсов, но без создания новой вертикали (страницы) - на будущее
  // TODO - задача EXP-26202
  DEFAULT: 'default',
} as const;
